"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asMapFactory = void 0;
/**
 * Create a MapCollector for the given grouping.
 *
 * @param groups The grouping.
 * @returns The created collector.
 */
function asMapFactory(groups) {
    return () => {
        const map = new Map();
        for (const group of groups) {
            map.set(group.key, group.items);
        }
        return map;
    };
}
exports.asMapFactory = asMapFactory;
